// SHFT-5757: single source of truth for "what version is this running tab".
// Read directly from package.json (tsconfig has resolveJsonModule: true)
// rather than duplicating the version string in a second place.
// eslint-disable-next-line @typescript-eslint/no-var-requires
const pkg: { version: string } = require('../../../package.json');

export const APP_VERSION: string = pkg.version;

/**
 * Simple dot-separated integer version comparison (no semver dependency
 * needed) - mirrors the check used on the mobile apps. Returns true if
 * `current` is strictly older than `minimum`.
 */
export function isVersionBelowMinimum(current: string, minimum: string): boolean {
  const currentParts = String(current)
    .split('.')
    .map(part => parseInt(part, 10) || 0);
  const minimumParts = String(minimum)
    .split('.')
    .map(part => parseInt(part, 10) || 0);
  const length = Math.max(currentParts.length, minimumParts.length);

  for (let i = 0; i < length; i++) {
    const currentPart = currentParts[i] || 0;
    const minimumPart = minimumParts[i] || 0;
    if (currentPart < minimumPart) return true;
    if (currentPart > minimumPart) return false;
  }
  return false;
}
